<template>
  <el-dialog class="corporateTransferPage" width="824px" title="对公账号转账充值" :visible.sync="showCorporateTransferBox" :before-close="handleClose">
    <el-table  :data="tableData" class="corporateTransferTable new-table-box" :header-cell-style="{ background: '#fafafa', 'line-height': '48px', height: '48px' }">
      <el-table-column label="公司名称" prop="name">
        <template  slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="账号" prop="num">
        <template slot-scope="scope">
          {{ scope.row.num }}
        </template>
      </el-table-column>
      <el-table-column label="开户行/ 行号" prop="number" width="264px">
        <template slot-scope="scope">
          <div>
            {{ scope.row.number }}
          </div>
          <div>
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="tip">
      转账成功后，提供付款截图给客服或您的对接商务即可
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      showCorporateTransferBox: false,
      tableData: [
        {
          name: '广州悦信无线科技有限公司',
          num: '38610188000280759',
          number: "中国光大银行股份有限公司广州分行",
          code: "303581038618"
        }
      ]
    }
  },
  mounted() {
    this.showCorporateTransferBox = true;
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.corporateTransferPage {
  .tip {
    margin-top: 20px;
    color: #666666;
    font-size: 14px;
    font-family: PingFang SC;
    line-height: 20px;
  }
  ::v-deep  .el-table .cell {
    padding-left: 30px!important;
  }
  ::v-deep .el-dialog {
    margin-top: 24vh !important;
  }
}
</style>